import { fgFilterEntries } from "@redotech/redo-fulfillment-operations-common/views/fulfillment/fg-filter-catalog";
import FileIcon from "@redotech/redo-icons/file-06.svg";
import { BooleanFilterOperator } from "@redotech/redo-views-common/advanced-filters/boolean-filter";
import { BooleanTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

const entry = fgFilterEntries.commercialInvoiceElectronic;

export const CommercialInvoiceElectronicFilter: BooleanTableFilter = {
  type: entry.type,
  operators: entry.operators,
  data: {
    name: entry.name,
    type: entry.type,
    value: true,
    operator: BooleanFilterOperator.IS,
  },
  boolDisplay: {
    falseDisplay: "not submitted electronically",
    trueDisplay: "submitted electronically",
  },
  Icon: FileIcon,
  displayName: entry.displayName,
  label: "Commercial invoice",
};
